import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useStyles from "../css/styles";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../App";

// Update log
// FB  6192   02/06/2023  DK   Added warning modal for session time out

export const TimeoutWarningModal = ({ isOpen, onRequestClose }) => {
  const styles = useStyles();
  const navigate = useNavigate();
  const context = useContext(UserContext);
  const onLogOffCall = () => {
    sessionStorage.removeItem("user");
    context.setUserLoggedIn(false);
    navigate("/user/login");
    onRequestClose();
  };

  return (
    <div>
      <Dialog open={isOpen}>
        <DialogTitle>Session Timeout</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your session has been expired. Please re-login.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className={styles.navigationButton}
            onClick={onLogOffCall}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
